import { render, staticRenderFns } from "./SelectBankType.vue?vue&type=template&id=728a64a5"
import script from "./SelectBankType.vue?vue&type=script&lang=ts"
export * from "./SelectBankType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728a64a5')) {
      api.createRecord('728a64a5', component.options)
    } else {
      api.reload('728a64a5', component.options)
    }
    module.hot.accept("./SelectBankType.vue?vue&type=template&id=728a64a5", function () {
      api.rerender('728a64a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/SelectBankType.vue"
export default component.exports